import { Reward, RewardType } from './reward';

export interface Milestone {
  id: number;
  type: MilestoneType;
  levelNumber: number;
  metadata: MilestoneMetadata;
}

export interface MilestoneMetadata {
  reward: Reward;
}

export enum MilestoneType {
  Primary = 0,
  Secondary = 1,
}

export const MilestoneTypeLabels: Record<MilestoneType, string> = {
  [MilestoneType.Primary]: 'Primary',
  [MilestoneType.Secondary]: 'Secondary',
};
